@if (
  {
    results: (searchParams.results | async) || [],
    isvalid: searchParams.isValid | async,
    messages: (searchParams.messages | async) || []
  };
  as data
) {
  <h2 class="visuallyhidden" i18n="@@lounge_searchCriteria">Search Criteria</h2>
  <div class="background-container-background">
    <app-validate-errors [messages]="data.messages"></app-validate-errors>
    <a href="#parking" (click)="skipToResultContent()" class="sr-only sr-only-focusable"
      >Skip to Result Content</a
    >
    <app-invoked-user></app-invoked-user>
    <app-search-toggle [serviceType]="ServiceType.Lounge">
      <app-lounge-search></app-lounge-search>
      <div class="flex-row-container flex-row-container--right">
        <button
          appButton="large-search"
          type="button"
          [disabled]="!data.isvalid"
          (click)="performSearch()"
          i18n="@@loungeSearch"
        >
          Search
        </button>
      </div>
    </app-search-toggle>
    <!-- TODO: - Make this country code dynamic -->
  </div>
  @if (!searchService.search_loading) {
    <app-risk-alerts [countryCode]="searchParams.locationCode?.countryCode"></app-risk-alerts>
  }
  <app-lounge-loading-screen [animated]="false"></app-lounge-loading-screen>
  @if (!mapView) {
    <div id="lounge" class="pnl-results-container">
      @if (data.results && data.results.length === 0) {
        <app-no-results></app-no-results>
      }
      <ul class="lounge-results-list results-width" role="list">
        @for (item of data?.results | loungesPriceSort; track item; let j = $index) {
          <li>
            <div
              class="pnl-item"
              role="group"
              [attr.aria-label]="
                'Lounge option ' +
                (j + 1) +
                ': ' +
                item.name +
                (item.airport ? ' at ' + item.airport : '')
              "
            >
              <div class="flex-row-container flex-row-container--between">
                <div class="pnl-desc">
                  <h3>{{ item?.name }}</h3>
                  @if (item.lounge.terminal) {
                    <div><span i18n="@@pnlTerminal">Terminal</span> {{ item.lounge.terminal }}</div>
                  }
                  @if (item.travelTypes && item.travelTypes.length) {
                    <div>
                      @for (type of item.travelTypes; track type; let i = $index) {
                        @if (type) {
                          <div>
                            <i class="ico-check-1 light-color-primary" aria-hidden="true"></i>
                            {{ type }}
                          </div>
                        }
                      }
                    </div>
                  }
                  <div class="pnl-features">
                    @if (
                      item.lounge.misc.issuitableforinternational === 1 ||
                      item.lounge.misc.issuitablefordomestic === 1
                    ) {
                      <div class="pnl-feature">
                        @if (item.lounge.misc.issuitableforinternational === 1) {
                          <i class="ico-check-1 light-color-primary" aria-hidden="true"></i>
                        } @else {
                          <i class="ico-cancel light-color-warning"></i>
                        }
                        <span i18n="@@pnlInternationalFlights">International flights</span>
                      </div>
                      <div class="pnl-feature">
                        @if (item.lounge.misc.issuitablefordomestic === 1) {
                          <i class="ico-check-1 light-color-primary" aria-hidden="true"></i>
                        } @else {
                          <i class="ico-cancel light-color-warning"></i>
                        }
                        <span i18n="@@pnlDomesticFlights">Domestic flights</span>
                      </div>
                    } @else {
                      <div class="pnl-feature">
                        <i class="ico-exclaim-1 light-color-info" aria-hidden="true"></i>
                        <span i18n="@@pnlInformationUnavailable">Information unavailable</span>
                      </div>
                    }
                  </div>
                  <app-preferred-icons
                    [tmcPreferred]="item.tmcPreferred"
                    [tmcPreferredLogoUrl]="item.tmcPreferredLogoUrl"
                    [tmcPreferredMessage]="item.tmcPreferredMessage"
                    [clientPreferred]="item.officePreferred || item.companyPreferred"
                    [companyPreferredMessage]="item.companyPreferredMessage"
                    [officePreferredMessage]="item.officePreferredMessage"
                  >
                  </app-preferred-icons>
                </div>
                <button
                  appButton="primary"
                  [iconOnly]="true"
                  (click)="toggleItemPhotos(item.lounge.furtherImages)"
                  attr.aria-label="Show photos for {{ item.name }}"
                >
                  <app-photos-icon></app-photos-icon>
                </button>
              </div>
              @if (item.lounge.logo | removeSpaces; as logo) {
                <div class="pnl-image">
                  <img [src]="logo" alt="{{ item.name }} logo" />
                </div>
              } @else if (item.lounge.furtherImages && item.lounge.furtherImages[0]) {
                <div class="pnl-image">
                  <img [src]="item.lounge.furtherImages[0]" alt="{{ item.name }} logo" />
                </div>
              }
              <div class="pnl-actions">
                <div class="lounge_results_rate">
                  <span class="daily_rate">
                    <span id="daily_rate_{{ index }}"> {{ item.price | number: '1.2-2' }} </span>
                    <em>{{ item.currency }}</em>
                  </span>
                  <span class="rate_plan" i18n="@@carsTotalPrice"> Total Price </span>
                  <app-warning-tags [iconId]="j" [ticket]="item"></app-warning-tags>
                </div>
                <div class="flex-column-container lounge-buttons-wrapper">
                  <button
                    appButton="small"
                    [disabled]="item.unavailable && !canOverride"
                    (click)="addToCart(item)"
                    id="lounge-add-to-basket-{{ j }}"
                    attr.aria-label="{{
                      item.price | currency: item.currency || 'GBP'
                    }} add to cart {{ item.name }}"
                  >
                    @if (!displayItinerary) {
                      <span i18n="@@pnlAddToCart">Add to basket</span>
                    }
                    @if (displayItinerary) {
                      <span i18n="@@pnlAddToItinerary">Add to itinerary</span>
                    }
                  </button>
                  <button
                    appButton="small"
                    (click)="openLoungeDetails(item)"
                    id="lounge-details-{{ j }}"
                    attr.aria-label="Additional details for {{
                      item?.price | currency: item.currency || 'GBP'
                    }} {{ item.name }}"
                  >
                    <span i18n="@@pnlAdditionalDetails">Additional Details</span>
                  </button>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  }
  @if (mapView) {
    <app-map-view [item]="selectedItem" (closeMapView)="onCloseMapView()"></app-map-view>
  }
}
